__webpack_require__.p = "https://weather-widget-vue.arapov.net/";